export const SEPARATORS = /[\n\s;:,./\\]+/;
export const NUMBER_ONLY = /^\d+$/g;
export const PHONE_NUMBER_ONLY = /(\+84|0)\d{9,10}/;
